var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 122 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_139_4906)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.351 79.3594C88.4168 79.3594 78.7012 89.1064 78.7012 101.178C78.7012 113.251 88.3724 122.998 100.351 122.998C112.329 122.998 122 113.251 122 101.178C122 89.1511 112.329 79.4041 100.351 79.3594ZM110.066 96.6179L99.8182 109.271C99.3302 109.897 98.6204 110.255 97.8218 110.3C97.7331 110.3 97.6888 110.3 97.6 110.3C96.8902 110.3 96.2248 110.031 95.6924 109.584L90.9011 105.202C89.7477 104.129 89.659 102.341 90.6793 101.178C91.6997 100.016 93.5186 99.9266 94.672 100.955L97.2895 103.325L105.63 92.9516C106.606 91.7444 108.38 91.5656 109.623 92.5492C110.82 93.5329 110.998 95.3213 110.022 96.5285L110.066 96.6179Z",
    fill: "#00A90B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.76362 118.485H80.8303C76.6158 113.745 74.3089 107.575 74.3089 101.182C74.3089 86.6504 85.9765 74.9361 100.395 74.8914C101.681 74.8914 102.968 74.9808 104.254 75.2044V7.82447C104.254 3.53219 100.75 0 96.4907 0H7.76362C3.50472 0 0 3.53219 0 7.82447V110.66C0 114.953 3.50472 118.485 7.76362 118.485ZM17.7454 16.7667C17.7454 14.9336 19.2538 13.4134 21.0727 13.4134H83.1816C85.0005 13.4134 86.5089 14.9336 86.5089 16.7667V57.0069C86.5089 58.84 85.0005 60.3602 83.1816 60.3602H75.1075L74.442 58.7059C73.0667 55.2184 70.2275 52.5805 66.7227 51.3732L59.5802 48.9588C58.9148 48.7353 58.5599 48.0199 58.7817 47.3492C58.8704 47.1257 59.0035 46.9021 59.2253 46.768C62.8188 43.5935 64.8151 38.9882 64.682 34.2041C65.3031 26.5138 59.7133 19.7177 52.0828 18.9576C44.4523 19.7177 38.8624 26.5138 39.4835 34.2041C39.3948 38.9882 41.3912 43.5935 44.9403 46.768C45.517 47.2151 45.6057 47.9752 45.1621 48.5564C45.029 48.7353 44.8072 48.9141 44.5853 49.0036L37.4428 51.418C33.9381 52.5805 31.0988 55.2631 29.7236 58.7506L29.0581 60.4049H20.9839C19.165 60.4049 17.6567 58.8847 17.6567 57.0516V16.7667H17.7454ZM21.0727 76.0092H65.4362C67.2551 76.0092 68.7635 77.5293 68.7635 79.3625C68.7635 81.1957 67.2551 82.7159 65.4362 82.7159H21.0727C19.2538 82.7159 17.7454 81.1957 17.7454 79.3625C17.7454 77.5293 19.2538 76.0092 21.0727 76.0092ZM21.0727 91.6581H56.5635C58.3824 91.6581 59.8908 93.1783 59.8908 95.0115C59.8908 96.8446 58.3824 98.3648 56.5635 98.3648H21.0727C19.2538 98.3648 17.7454 96.8446 17.7454 95.0115C17.7454 93.1783 19.2538 91.6581 21.0727 91.6581Z",
    fill: "#00A90B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_139_4906",
    x: 0,
    y: 0,
    width: 122,
    height: 127,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_139_4906"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.24607dd1f714c10fb4379ef0004eef42.svg";
export { ForwardRef as ReactComponent };